import { BaseService } from './baseService';
import { PatientMedicineDto, PatientsMedicineFormData } from '../types/patientMedicine';

class PatientMedicineService extends BaseService<PatientMedicineDto, PatientsMedicineFormData> {
    constructor() {
        super('/PatientsMedicine');
    }
}

export const patientMedicineService = new PatientMedicineService();